import { submitSubscriptionData } from '../../api/subscribe-bis';
import {
  CLASS_BOOST_SD_BIS_NOTIFY_POPUP_SHOWED,
  CLASS_BOOST_SD_BIS_SUCCESS_BANNER_SHOWED,
  ID_CLOSE_BUTTON,
  ID_EMAIL_INPUT,
  ID_ERROR_MESSAGE_EMAIL,
  ID_ERROR_MESSAGE_PHONE,
  ID_NOTIFY_BUTTON,
  ID_PHONE_INPUT,
  ID_POPUP,
  ID_SUBMIT_BUTTON,
  ID_SUCCESS_BANNER,
  ID_VARIANT_SELECT,
  MODAL_OPEN_CLASS,
  SELECTOR_PHONE_CONTAINER,
  SELECTOR_PHONE_DROPDOWN,
  SUCCESS_BANNER_TIMEOUT,
} from '../constants';
import { enhanceAccessibility } from '../ui/accessibility';
import { handleEmailValidation } from '../ui/email-validation';
import { phoneDropdown } from '../ui/phone-dropdown';
import { handlePhoneValidation } from '../ui/phone-validation';
import { closePopup, openPopup } from '../ui/popup';
import { handleDropdownEvents } from '../ui/variant-dropdown';

/**
 * @type {import('../index.d').bindBackInStockEvents}
 */
export function bindBackInStockEvents(context, product) {
  const notifyButton = document.getElementById(ID_NOTIFY_BUTTON);
  const popup = document.getElementById(ID_POPUP);
  const closeButton = document.getElementById(ID_CLOSE_BUTTON);
  const emailInput = document.getElementById(ID_EMAIL_INPUT);
  const phoneInput = document.getElementById(ID_PHONE_INPUT);
  const phoneDropdownElement = document.querySelector(SELECTOR_PHONE_DROPDOWN);
  const phoneContainerElement = document.querySelector(SELECTOR_PHONE_CONTAINER);
  const variantSelect = document.getElementById(ID_VARIANT_SELECT);
  const submitButton = document.getElementById(ID_SUBMIT_BUTTON);
  const errorMessageElement = document.getElementById(ID_ERROR_MESSAGE_EMAIL);
  const phoneErrorMessage = document.getElementById(ID_ERROR_MESSAGE_PHONE);
  const successBanner = document.getElementById(ID_SUCCESS_BANNER);

  if (!notifyButton) return;

  notifyButton.addEventListener('click', (e) => {
    e.preventDefault();
    openPopup(popup, closeButton);
  });

  if (closeButton) {
    closeButton.addEventListener('click', () => closePopup(popup, notifyButton));
  }

  if (variantSelect) handleDropdownEvents(context, variantSelect);

  if (emailInput) {
    emailInput.addEventListener('input', () => {
      handleEmailValidation(emailInput, errorMessageElement, submitButton);
    });
  }

  if (phoneContainerElement && phoneDropdownElement) {
    phoneDropdown.init(context, phoneContainerElement, phoneDropdownElement);
  }

  if (phoneInput) {
    phoneInput.addEventListener('input', () => {
      handlePhoneValidation(phoneInput, phoneErrorMessage, submitButton);
    });
  }

  if (submitButton) {
    submitButton.addEventListener('click', async () => {
      try {
        const selectedOption = variantSelect?.querySelector(
          '.boost-sd__bis-dropdown-option-item--selected'
        );
        const variantId = selectedOption?.dataset?.variantId;
        const email = emailInput.value;
        const phoneNumber = phoneInput?.value || '';

        if (!email) {
          console.error('Variant ID or Email is missing.');
          return;
        }

        if (phoneNumber && !handlePhoneValidation(phoneInput, phoneErrorMessage, true)) {
          console.error('Invalid phone number.');
          return;
        }

        const subscriptionData = {
          email,
          phone: phoneNumber || null,
          variantId,
          productId: product.id,
        };
        const response = await submitSubscriptionData(context, subscriptionData);

        if (response.success) {
          popup.setAttribute('aria-hidden', 'true');
          popup?.classList?.remove(CLASS_BOOST_SD_BIS_NOTIFY_POPUP_SHOWED);
          document.body.classList.remove(MODAL_OPEN_CLASS);

          successBanner.setAttribute('aria-hidden', 'false');
          successBanner.classList.add(CLASS_BOOST_SD_BIS_SUCCESS_BANNER_SHOWED);

          setTimeout(() => {
            successBanner.setAttribute('aria-hidden', 'true');
            successBanner.classList.remove(CLASS_BOOST_SD_BIS_SUCCESS_BANNER_SHOWED);
          }, SUCCESS_BANNER_TIMEOUT);

          emailInput.value = '';
          phoneInput.value = '';
          submitButton.disabled = true;
        } else {
          console.error('Subscription failed:', response.message);
        }
      } catch (error) {
        console.error('Failed to submit Back-in-Stock subscription:', error);
      }
    });
  }

  enhanceAccessibility(popup, closeButton, notifyButton, variantSelect);
}
